<template>
  <div>
    <b-form-file
        id="fileInput"
        :label="label"
        :multiple="multiple"
        :required="required"
        :accept="accept"
        :state="validationState"
        @change="setFilePreview"
        :placeholder="label || 'Choose file'"
        drop-placeholder="Drop file here..."
    >
      <template v-slot:file-name="{ names }">
        <b-badge variant="primary" class="mr-1" v-for="name in names" :key="name">
          {{ name }}
        </b-badge>
      </template>
    </b-form-file>

    <div v-if="files.length > 0 && required && !files.length" class="text-danger mt-1 small">
      انتخاب عکس اجباری است
    </div>

    <div v-if="files.length > 0 && withPreview" class="d-flex mt-2 flex-wrap gap-2">
      <div v-for="(item, idx) in files" :key="idx" class="position-relative" style="width: 10rem; height: 10rem">
        <b-icon-x
            class="position-absolute delete-icon"
            variant="danger"
            @click="deleteMedia(item, idx)"
            style="cursor: pointer; z-index: 999; right: -8px; top: -8px; background: white; border-radius: 50%;"
        ></b-icon-x>

        <video
            v-if="isVideo"
            :src="item"
            id="videoElement"
            class="h-100 w-100"
            controls
            style="object-fit: cover"
        ></video>

        <b-img
            v-else
            :src="item"
            class="w-100 h-100"
            style="object-fit: cover"
            fluid
        ></b-img>
      </div>
    </div>

    <div v-if="!withPreview && files.length > 0" class="d-flex mt-2 w-100 flex-column">
      <div v-for="(item, idx) in files" :key="idx"
           class="position-relative d-flex align-items-center justify-content-between mb-2">
        <b-icon-x
            variant="danger"
            @click="deleteMedia(item, idx)"
            style="cursor: pointer"
        ></b-icon-x>
        <span class="ml-2">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {DeleteMediaForBlog, UploaderForBlog} from "@/libs/Api/Blog";
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BIconX,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
  BPagination,
  BRow,
} from "bootstrap-vue";

export default {
  name: "Uploader",
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BBadge,
    BFormGroup,
    BImg,
    BIconX,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormFile,
    BFormSelect,
    BFormTextarea,
    BButton,
    BPagination,
    BOverlay,
  },
  props: {
    accept: {
      type: String,
      default: '/*'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    withPreview: {
      type: Boolean,
      default: true
    },
    sizeLimit: {
      type: Number,
      default: 0
    },
    fileType: {
      type: Number,
      default: 6,
      required: true
    },
    defaultMedias: {
      type: [Array, String, Object],
      default: null
    }
  },

  data() {
    return {
      files: []
    };
  },

  computed: {
    validationState() {
      if (this.required && this.files.length === 0) {
        return false;
      }
      return null;
    },
    fermanSecretKey() {
      return process.env.VUE_APP_BLOG_SECRET
    }
  },

  mounted() {
    if (this.defaultMedias) {
      if (Array.isArray(this.defaultMedias)) {
        this.defaultMedias.forEach((file) => {
          if (file.base64) {
            this.files.push(file.base64);
          }
        });
      } else {
        this.files.push(this.defaultMedias);
      }
    }
  },

  methods: {
    getFiles() {
      this.$emit('getFiles', this.files);
      this.files = [];
    },

    setFilePreview(event) {
      const inputFiles = event.target.files;
      Array.prototype.forEach.call(inputFiles, (file) => {
        this.uploadMedia(file);
      });
    },

    async uploadMedia(file) {
      if (this.sizeLimit) {
        if (file.size > this.sizeLimit) {
          this.alert.error(`اندازه عکس انتخاب شده نمیتواند بزرگتر از ${this.sizeLimit / 1000} مگابایت باشد`);
          return;
        }
      }
      try {
        const _this = this;
        const myForm = new FormData();
        myForm.append('file', file);
        myForm.append('FileType', this.fileType);
        myForm.append('SecretKey', this.fermanSecretKey);
        const uploaderForBlog = new UploaderForBlog(_this);
        uploaderForBlog.setFormData(myForm);
        await uploaderForBlog.sendFormData((res) => {
          if (res.data.isSuccess) {
            if (!this.multiple) {
              this.files = [];
            }
            this.files.push(res.data.data.url);
          } else {
          }

        });
      } catch (error) {
        console.error(error);
      } finally {

      }
    },

    async deleteMedia(item, idx) {
      try {
        this.isLoading = true;
        let _this = this;
        const fileId = item.split('/').filter(e => e)[6];
        let deleteMediaForBlog = new DeleteMediaForBlog(_this);
        deleteMediaForBlog.setParams(fileId);
        deleteMediaForBlog.setSecretKey({
          secretKey: this.fermanSecretKey
        });
        await deleteMediaForBlog.fetch((response) => {
          if (response.isSuccess) {
            this.files.splice(idx, 1);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }
  },

  created() {
  }
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

.delete-icon {
  cursor: pointer;
  z-index: 999;
  background: white;
  border-radius: 50%;
  padding: 2px;
}

.position-relative {
  position: relative;
}

.position-absolute {
  position: absolute;
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.d-flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.align-items-center {
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.flex-column {
  flex-direction: column;
}

.small {
  font-size: 0.875rem;
}

.text-danger {
  color: #dc3545;
}
</style>
